import { useRouter } from 'next/router'
import { Language } from 'types/language'
import { LanguageCase, UseGetLanguage } from './types'
import { getUpperCaseLanguage, isValidLowercaseLanguage } from 'utils/language'

export const useGetLanguage = ((languageCase: LanguageCase = 'lowercase') => {
  const { locale = '' } = useRouter()

  if (languageCase === 'uppercase') {
    return getUpperCaseLanguage(locale)
  }

  return isValidLowercaseLanguage(locale) ? locale : Language.DUTCH
}) as UseGetLanguage
